import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export const SiteLayout = ({ data, current, children }) => (
  <>
    <Header current={current} summitOn={!!data.summit?.published} />
    <main>{children}</main>
    <Footer settings={data.settings} />
  </>
);
